/* ImportScreenComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ImportScreenRenderer");

class ImportScreenComponent extends EventEmitter {
    constructor(logger, userSession, io) {
        super();
        this._logger = logger;

        this._userSession = userSession;
        this._io = io;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    get logger() {
        return this._logger;
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._io = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "ImportScreenComponent.shutdown() error.");
            }
        );
    }
    sendImportData(data) {
        this._context.resolve({
            action: "bulkImport",
            importData: data
        });
    }
    sendImportError(err) {
        this._context.reject(err);
    }

    syncDevicesFromOrgNodes() {
        this._context.resolve({
            action: "syncDevicesFromOrgNodes"
        });
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ImportScreenComponent;
